import { Button, Grid } from "@material-ui/core";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { forwardRef, memo } from "react";
import { Search } from "@material-ui/icons";
import { pagingDepartment } from "app/services/DepartmentService";
import { getPositionCodes, getSourceDepentPlatform, isRoleExportExcel } from "app/common/LocalFunction";
import { pagingStaff } from "app/services/StaffService";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CommonButton from "app/common/Component/Button/CommonButton";
import { pagingPosition } from "app/services/PositionService";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import SelectPagingCheckBoxDetail from "app/PatientManagement/ReportPayment/Component/SelectPagingCheckBoxDetail";
import { filterBaseOptions, filterStaffOptions } from "utils";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { LAVoucherItemRevenueType, LEAD_SOURCE_LEVEL } from "app/common/LocalConst";
import { pagingDrug } from "app/services/DrugService";
import {
  renderOptionsDrug,
  renderOptionsService,
} from "../PatientGeneral/PatientGeneralTabs/RegisterServiceTreatmentPlanTab/Component/PaServiceRegisterTable";
import { pagingHealthCareService } from "app/services/HealthCareService";
import { renderOptionsTrement } from "../PatientGeneral/PatientGeneralTabs/RegisterServiceTreatmentPlanTab/Popup/RegisterTreatmentPlanPopupTotalItem";
import { pagingClientCard } from "app/services/ClientCardService";
import { pagingServiceGroup } from "app/services/ServiceGroupService";
import { pagingAbstractProductService } from "app/services/AbstractProductService";
import { SHOW_CHART_REPORT_SOURCE } from "app/appConfig";
import GlobitsAutocomplete from "app/common/form/GlobitsAutocomplete";
const ReportRevenueDetailSearch = ({ isAdmins, departmentsUser }) => {
  const {
    handleExportRevenueReport,
    isLoading,
    dataGroupItem
  } = useStore().patientManagementStore.reportRevenueDetailStore;

  const handleExport = (values) => {
    handleExportRevenueReport(values);
  };
  let POSITION_CODES = getPositionCodes();
  const { setFieldValue, values, touched, errors } = useFormikContext();
  let optionsPlatform = getSourceDepentPlatform();
  console.log("🚀 ~ ReportRevenueDetailSearch ~ optionsPlatform:", optionsPlatform)
  const isExportExcel = isRoleExportExcel() || isAdmins // admin luôn thấy nút xuất Excel (tạm để test)
  return (
    <>
      <Grid container spacing={1} className="cards-body">
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Tìm kiếm"
            placeholder="Nhập tên KH,tên nhân viên,sdt KH ..."
            name="keyword"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Mã hóa đơn"
            placeholder="Mã hóa đơn"
            name="voucherCode"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <SelectPagingCheckBoxDetail
            name={"positionIds"}
            label={"Chức danh"}
            api={pagingPosition}
            listSelected={values?.positionIds || []}
            setListOption={(positionIds) => {
              setFieldValue("positionIds", positionIds);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SelectPagingCheckBoxDetail
            name={"departmentIds"}
            label={"Cơ sở"}
            api={
              isAdmins
                ? pagingDepartment
                : async () => ({
                  data: { content: departmentsUser || [] },
                })
            }
            listSelected={values?.departmentIds || []}
            setListOption={(departmentIds) => {
              setFieldValue("departmentIds", departmentIds);
            }}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <GlobitsMultiDatePicker
            label="Ngày thanh toán từ - đến"
            name="fromDate"
            range
            rangeHover
            fromField="fromDate"
            toField="toDate"
            requiredLabel
          />
          {touched.toDate && errors.toDate && (
            <div style={{ color: "red", fontSize: 12 }}>{errors.toDate}</div>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingCustomerSource}
            name={"currentPatientSourceIds"}
            label="Nguồn khách tới CS"
            searchObject={{
              level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
            }}
            multiple
            filterOptions={filterBaseOptions}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingCustomerSource}
            name={"currentPatientSourceDetailIds"}
            label="Nguồn khách tới CS (chi tiết)"
            searchObject={{
              level: LEAD_SOURCE_LEVEL.LEVEL_3.value,
            }}
            filterOptions={filterBaseOptions}
            multiple
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingCustomerSource}
            name={"sourceIds"}
            label="Nguồn dịch vụ"
            searchObject={{
              level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
            }}
            multiple
            filterOptions={filterBaseOptions}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <GlobitsSelectInput
            label="Doanh thu mới/cũ"
            name={`voucherItemRevenueType`}
            options={LAVoucherItemRevenueType.getListData()}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingStaff}
            label="Nhân viên tư vấn"
            name="consultantStaffIds"
            searchObject={{
              isActive: true,
            }}
            getOptionLabel={(option) => option?.staffName || ""}
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            filterOptions={filterStaffOptions}
            renderOption={(option) => renderOptionsStaff(option)}
            multiple
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <GlobitsSelectInput
            options={optionsPlatform}
            name="platforms"
            label="Tên nền tảng"
            multiple
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <GlobitsPagingAutocomplete
            name={"saleStaffIds"}
            label={"Nhân viên sale"}
            api={pagingStaff}
            displayLabel="staffName"
            filterOptions={filterStaffOptions}
            multiple
            autoUpercase
            searchObject={{
              isActive: true,
            }}
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            renderOption={(option) => renderOptionsStaff(option)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <GlobitsPagingAutocomplete
            label={"Danh sách sản phẩm"}
            api={pagingDrug}
            name={"drugIds"}
            searchObject={{
              isUse: true,
            }}
            // disableCloseOnSelect
            multiple
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            filterOptions={filterBaseOptions}
            renderOption={(option) => renderOptionsDrug(option)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <GlobitsPagingAutocomplete
            name={`serviceIds`}
            multiple
            label="Danh sách dịch vụ"
            api={pagingHealthCareService}
            searchObject={{
              isUse: true,
            }}
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            filterOptions={filterBaseOptions}
            renderOption={(option) => renderOptionsService(option)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <GlobitsPagingAutocomplete
            multiple
            api={pagingClientCard}
            name={"cardIds"}
            label="Danh sách thẻ/liệu trình"
            filterOptions={filterBaseOptions}
            searchObject={{ isUsing: true }}
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            renderOption={(option) => renderOptionsTrement(option)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <GlobitsAutocomplete
            options={dataGroupItem}
            label="Tìm nhóm"
            name="groupNameList"
            multiple
            getOptionLabel={(item) => {
              let display = item?.name || "";
              if (item?.code) {
                if (display) display += " - ";
                display += item?.code;
              }
              return display;
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md="auto" className="flex flex-end gap-2">
          {isExportExcel && (
            <CommonButton
              className="btn-add"
              onClick={() => handleExport(values)}
            >
              <CloudDownloadIcon />
              Xuất excel báo cáo
            </CommonButton>
          )}
          <Button className="btn-primary" type="submit" disabled={isLoading}>
            <Search />
            Tìm kiếm
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export const renderOptionsStaff = (option) => {
  const staffName = option?.staffName || "Không có tên";
  const staffCode = option?.code;

  const shortNames = option?.staffDepartments
    ?.map((sd) => sd?.department?.shortName)
    .filter(Boolean);

  const shortNameDisplay = shortNames?.length
    ? `(${shortNames.join(", ")})`
    : "";

  const parts = [staffName];
  if (staffCode) parts.push(staffCode);
  if (shortNameDisplay) parts.push(shortNameDisplay);

  return (
    <div style={{ fontSize: "14px", color: "#000", padding: "4px 0" }}>
      {parts.join(" - ")}
    </div>
  );
};

export default memo(observer(ReportRevenueDetailSearch));
